import { useEffect, useRef, useState } from 'react';

const items = [
  { label: 'Experience Design' },
  { label: 'Brand & Com Design' },
  { label: 'CX Design' },
  { label: 'Creative Development' },
];

export default function FormulaSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-12 lg:gap-0">

          {/* Left: formula stack */}
          <div className="flex flex-col gap-0">
            {items.map((item, index) => (
              <div key={index} className="flex flex-col">
                <div
                  className="flex items-center gap-4"
                  style={{
                    opacity: visible ? 1 : 0,
                    transform: visible ? 'translateY(0)' : 'translateY(24px)',
                    transition: `opacity 0.6s ease ${index * 0.15}s, transform 0.6s ease ${index * 0.15}s`,
                  }}
                >
                  <span className="text-3xl lg:text-5xl font-black text-black tracking-tight leading-tight">
                    {item.label}
                  </span>
                </div>
                {index < items.length - 1 && (
                  <div
                    className="text-3xl lg:text-4xl font-black text-black my-1 ml-1"
                    style={{
                      opacity: visible ? 1 : 0,
                      transition: `opacity 0.6s ease ${index * 0.15 + 0.1}s`,
                    }}
                  >
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; +
                  </div>
                )}
              </div>
            ))}

            {/* = box after Creative Development */}
            <div
              className="mt-4 flex items-center justify-center w-16 h-16 border-2 border-black rounded-lg"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(24px)',
                transition: `opacity 0.6s ease ${items.length * 0.15}s, transform 0.6s ease ${items.length * 0.15}s`,
              }}
            >
              <span className="text-3xl lg:text-4xl font-black text-black">=</span>
            </div>
          </div>

          {/* Center: equals - hidden now since = is in the left stack */}
          <div
            className="hidden lg:flex items-center justify-center text-5xl font-black text-black px-8"
            style={{
              opacity: visible ? 1 : 0,
              transition: 'opacity 0.6s ease 0.7s',
            }}
          >
            =
          </div>

          {/* Right: result */}
          <div
            className="flex items-center"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateX(0)' : 'translateX(40px)',
              transition: 'opacity 0.8s ease 0.8s, transform 0.8s ease 0.8s',
            }}
          >
            <span className="text-4xl lg:text-6xl font-black text-[#FF4500] leading-tight tracking-tight">
              Entertainment<br />Design
            </span>
          </div>

        </div>
      </div>
    </section>
  );
}
